<template>
    <div class="pa-4">
        <v-list>
            <v-list-item-group color="zoezi-edit-color">
                <v-list-item
                    v-for="site in sortedSites"
                    :key="site.id"
                    @click="switchHomepage(site)"
                    :class="{'v-item--active': site.id == $root.homepage_id, 'v-list-item--active': site.id == $root.homepage_id}"
                >
                    <v-list-item-content :title="site.domainname">
                        {{site.name}}
                    </v-list-item-content>

                    <v-list-item-icon v-if="site.domainname" @click="switchHomepage(site, true)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-list-item-icon>

                    <v-list-item-icon v-if="showEditAccessRights" @click.stop="showEditAccessDialogClicked(site.id)">
                        <v-icon>mdi-account-edit</v-icon>
                    </v-list-item-icon>

                    <v-list-item-icon v-if="$root.sites.length > 1" @click.stop="removeSite(site.id)">
                        <v-icon color="error">mdi-delete</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <v-dialog
            v-model="showAddHomePageDialog"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">
                    {{$translate('Add new homepage')}}
                    <v-btn icon @click="showAddHomePageDialog = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <v-text-field :label="$translate('Name')" v-model="newHomePage.name" color="zoezi-edit-color"/>
                    <!--<v-text-field label="BasePath" v-model="newHomePage.basepath" color="zoezi-edit-color"/>-->

                    <v-text-field :label="$translate('Domain')" v-model="copyFromSystem" color="zoezi-edit-color" :loading="loadingHomePages" v-if="copyOther" />

                    <v-select v-model="otherHomePage" :items="homepages" item-value="id" item-text="name" :label="$translate('Choose homepage')" v-if="copyOther" />

                    <label class="v-label theme--light">{{$translate('Choose homepage template')}}</label>

                    <home-page-template-palette v-model="newHomePage.template" />

                    <v-checkbox :label="$translate('Save as template page')" v-model="newHomePage.shared" v-if="shared" color="zoezi-edit-color" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        @click="addHomePage"
                        :disabled="!validNewHomePage"
                    >
                        {{$translate('Add')}}
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="accessDialog.show"
            max-width="800"
        >
            <v-card>
                <v-card-title class="headline zoezi-edit-color">
                    {{$translate('Edit access rights')}}
                    <v-btn icon @click="accessDialog.show = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card-text class="pt-4">
                    <!-- Simple table with columns domain name, user name and role name -->
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>{{$translate('Domain')}}</th>
                                    <th>{{$translate('User')}}</th>
                                    <th>{{$translate('Role')}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="access in accessDialog.list" :key="access.id">
                                    <td>{{ access.domain_name }}</td>
                                    <td>{{ access.user_name }}</td>
                                    <td>{{ $translate(access.role_name) }}</td>
                                    <td>
                                        <v-btn
                                            class="zoezi-button-thin"
                                            color="error"
                                            @click="removeAccess(access)"
                                            fab
                                            small
                                        >
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <v-text-field v-model="accessDialog.new.domain_name" color="zoezi-edit-color" :placeholder="$translate('Domain name')"/>
                                    </td>
                                    <td>
                                        <v-text-field v-model="accessDialog.new.user_id" color="zoezi-edit-color" :placeholder="$translate('User id')" />
                                    </td>
                                    <td>
                                        <v-text-field v-model="accessDialog.new.role_id" color="zoezi-edit-color" :placeholder="$translate('Role id')" />
                                    </td>
                                    <td>
                                        <v-btn
                                            class="zoezi-button-thin"
                                            color="zoezi-edit-color"
                                            fab
                                            small
                                            @click="addAccess"
                                            :disabled="!validNewAccess"
                                        >
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn
            v-if="hasAddPermission"
            @click="showAddForm"
            color="zoezi-edit-color"
            fab
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>


<script>
import HomePageTemplatePalette from './HomePageTemplatePalette.vue'
export default {
    name: 'zoezi-homepages',

    props: {
        shared: {
            type: Boolean,
            default: false
        }
    },

    components: {
        HomePageTemplatePalette
    },

    watch: {
        copyFromSystem(hostname) {
            if (this.copyOther && hostname && (hostname.endsWith('.gymsystem.se') || hostname.endsWith('.zoezi.se') || hostname.endsWith('.lokalsystem.se'))) {
                this.getHomePages(hostname);
            }
        },
        'newHomePage.template.id'(id) {
            if (id == 'copyother') {
                this.getHomePages(this.copyFromSystem);
            }
        }
    },

    data: () => ({
        newHomePage: {name: 'Ny hemsida', basepath: '', template: {}, shared: false},
        showAddHomePageDialog: false,
        copyFromSystem: 'zoezidev.se',
        otherHomePage: null,
        homepages: [],
        loadingHomePages: false,
        accessDialog: {
            show: false,
            homepage_id: null,
            list: [],
            new: {
                domain_name: '',
                user_id: '',
                role_id: ''
            }
        }
    }),
    computed: {
        sortedSites() {
            return this.$root.sites.filter(s => s.shared == this.shared && s.can_edit).sort((a, b) => a.name.localeCompare(b.name));
        },
        validNewHomePage() {
            return !this.$root.sites.find(site => site.name == this.newHomePage.name) && this.newHomePage.template.id;
        },
        copyOther() {
            return this.newHomePage.template.id == 'copyother';
        },
        hasAddPermission() {
            if (this.$store.state.user.superUser) {
                return true;
            }

            if (this.shared) {
                return this.$store.state.user.permissions.find(x => x == 'Change shared homepage');
            }

            return this.$store.state.user.permissions.find(x => x == 'Change homepage');
        },
        showEditAccessRights() {
            return this.shared && this.$store.state.user?.superUser;
        },
        validNewAccess() {
            const { user_id, role_id, domain_name } = this.accessDialog.new;
            const domain_ok = domain_name && domain_name.length > 0;
            const user_ok = user_id && Number.isInteger(Number(user_id));
            const role_ok = role_id && Number.isInteger(Number(role_id));
            const only_one_set = (user_ok && !role_id) || (!user_id && role_ok);
            return domain_ok && only_one_set;
        }
    },
    methods: {
        switchHomepage(site, local) {
            if(site.domainname && !local) {
                document.location.href = 'https://' + site.domainname;
            } else {
                if (site.id != this.$root.homepage_id) {
                    this.$root.switchHomepage(site.id)
                }
            }
        },
        removeSite(site_id) {
            let switchTo = this.$root.homepage_id == site_id ? this.$root.sites.filter(site => site.id != this.$root.homepage_id)[0] : null;
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove homepage'),
                text: this.$translate('Are you sure you want to remove this homepage?'),
                actionText: this.$translate('Delete'),
                actionColor: 'error',
                action: () => {
                    this.$api.post('/api/homepage/remove', null, {id: site_id}).then(() => {
                    if (switchTo) {
                        this.$root.switchHomepage(switchTo.id)
                    } else {
                        this.$root.loadSites();
                    }
                    });
                }
            });
        },
        showAddForm() {
            this.showAddHomePageDialog = true;
            let n = 1;
            this.$root.sites.forEach(s => {
                let rx = s.basepath?.match(/\/(\d+)$/);
                if(rx && Number(rx[1]) >= n) n = Number(rx[1]);
            })
            this.newHomePage.basepath = `/homepage/${n+1}`;
            this.newHomePage.shared = this.shared;
        },
        addHomePage() {
            if (this.newHomePage.template.id == 'empty') {
                this.$root.addEmptyHomepage(this.newHomePage.name, this.newHomePage.basepath, this.newHomePage.shared);
            } else if (this.newHomePage.template.id == 'copy') {
                this.$root.addCopyOfThisHomepage(this.newHomePage.name, this.newHomePage.basepath, this.newHomePage.shared);
            } else if (this.newHomePage.template.id == 'copyother') {
                this.getHomePage().then(copiedHp => {
                    this.$root.addHomePageWithConfig(this.newHomePage.name, copiedHp.config, this.newHomePage.basepath, this.newHomePage.shared, copiedHp.type);
                });
            } else if (this.newHomePage.template.id == 'sf') {
                this.$root.addEmptyHomepage(this.newHomePage.name, this.newHomePage.basepath, this.newHomePage.shared, 'sf');
            } else {
                this.$root.addHomePageWithConfig(this.newHomePage.name, this.newHomePage.template.config, null, this.newHomePage.shared, 'mb');
            }
        },
        getHostname(hostname) {
            if (!hostname.startsWith('https://')) {
                hostname = 'https://' + hostname;
            }

            return hostname;
        },
        getHomePage() {
            return fetch(`${this.getHostname(this.copyFromSystem)}/api/homepage/get?id=${this.otherHomePage}`).then(response => response.json().then(data => {
                return data;
            }));
        },
        getHomePages(hostname) {
            this.homepages = [];
            this.loadingHomepages = true;
            fetch(`${this.getHostname(hostname)}/api/homepage/get/all`).then(response => response.json().then(homepages => {
                this.homepages = homepages.sort((a,b) => a.name.localeCompare(b.name));
                this.loadingHomepages = false;
            }))
        },
        getAccessList(homepage_id) {
            this.accessDialog.list = [];
            this.$api.get('/api/homepage/access/get', {homepage_id}).then((response) => {
                this.accessDialog.list = response;
            })
        },
        showEditAccessDialogClicked(homepage_id) {
            this.accessDialog.show = true;
            this.accessDialog.homepage_id = homepage_id;
            this.getAccessList(homepage_id);
        },
        addAccess() {
            this.$api.post('/api/homepage/access/add', null, {homepage_id: this.accessDialog.homepage_id, ...this.accessDialog.new}).then((response) => {
                if (response.ok) {
                    this.getAccessList(this.accessDialog.homepage_id);
                    this.accessDialog.new = {domain_name: '', user_id: '', role_id: ''};
                } else {
                    this.$store.commit('showSnackBar', {text: 'Failed to change access rights'});
                }
            })
        },
        removeAccess(access) {
            this.$api.post('/api/homepage/access/remove', null, {id: access.id}).then((response) => {
                if (response.ok) {
                    this.getAccessList(this.accessDialog.homepage_id);
                } else {
                    this.$store.commit('showSnackBar', {text: 'Failed to change access rights'});
                }
            })
        }
    },
    mounted(){
        if(!this.$root.sitesLoaded) {
            this.$root.loadSites();
        }
    }
}
</script>
